.mainWrapper {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  grid-area: auto;
}

.dynamicPageContentContainer {
  width: -webkit-fill-available;
  width: -moz-available;
  width: stretch;
  max-width: var(--ogm-max-width);
  margin: 0 auto;
  display: grid;
  grid-template-rows: auto;
  gap: 20px;
  padding: 0 16px;
}

@media (min-width: 768px) {
  .dynamicPageContentContainer {
    gap: 40px;
  }
}

.standard {
  grid-template-areas:
    'top'
    'centerTop'
    'centerBottom'
    'bottom';
  grid-template-columns: 1fr;
}

.standardWithRight {
  grid-template-areas:
    'top'
    'centerTop'
    'right'
    'centerBottom'
    'bottom';
  grid-template-columns: 1fr;
}

@media (min-width: 1024px) {
  .standardWithRight {
    grid-template-areas:
      'top top'
      'centerTop right'
      'centerBottom right'
      'bottom bottom';
    grid-template-columns: 1fr minmax(300px, 360px);
    grid-template-rows: auto auto 1fr auto;
  }
}

.dynamicPageTop {
  grid-area: top;
}

.dynamicPageCenterTop {
  grid-area: centerTop;
}

.dynamicPageRight {
  grid-area: right;
}

.dynamicPageCenterBottom {
  grid-area: centerBottom;
}

.dynamicPageBottom {
  grid-area: bottom;
}

.dynamicPageTop,
.dynamicPageCenterTop,
.dynamicPageRight,
.dynamicPageCenterBottom,
.dynamicPageBottom {
  display: none;
  overflow-x: hidden;
}

.dynamicPageTop.show,
.dynamicPageBottom.show {
  display: block;
  overflow-x: unset;
}

.dynamicPageCenterTop.show,
.dynamicPageRight.show,
.dynamicPageCenterBottom.show {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dynamicPageCenterTop.show:last-child,
.dynamicPageRight.show:last-child,
.dynamicPageCenterBottom.show:last-child {
  gap: 0;
}

/*
Ensure child elements only take up the width
of the below parent containers
*/
.dynamicPageContentContainer > *,
.dynamicPageTop > *,
.dynamicPageCenterTop > *,
.dynamicPageRight > *,
.dynamicPageCenterBottom > *,
.dynamicPageBottom > * {
  max-width: 100%;
}

/* Edge case dynamic styles for containers ---------------------------- */

.mainWrapper.gridGroup {
  background-color: var(--ogm-ghostwhite);
}

.dynamicPageContentContainer.gridGroup {
  padding: 0 0 20px 0;
}

.dynamicPageContentContainer.gridGroup,
.dynamicPageTop.gridGroup,
.dynamicPageCenterTop.gridGroup,
.dynamicPageRight.gridGroup,
.dynamicPageCenterBottom.gridGroup,
.dynamicPageBottom.gridGroup {
  display: block;
  gap: 0;
  overflow-x: unset;
}

.dynamicPageContentContainer.gridGroup .dynamicPageRight,
.dynamicPageContentContainer.gridGroup .dynamicPageCenterBottom {
  padding: 20px 16px 0 16px;
}
